import React from 'react';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const localeCompare = (a, b) => a.localeCompare(b);

const FilterGroup = ({ filter, toggleFilter }) => (
  <div data-bem="FilterGroup" className="filter-group">
    <div className="sub-brand">
      {Object.keys(filter.values)
        .sort(localeCompare)
        .map((name, index) => {
          const handleClick = () => void toggleFilter(filter, name);
          const key = `${name}_${index}`;
          const isSelected = fromAnyToBool(filter.values[name]);

          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div className={isSelected ? 'item selected' : 'item not-selected'} onClick={handleClick} key={key}>
              <div className="check-icon" />
              <div className="name"> {name}</div>
            </div>
          );
        })}
    </div>
  </div>
);

export default FilterGroup;
